/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ date: NonNullable<unknown> }} Settings_Keys_Last_UsedInputs */

const en_settings_keys_last_used = /** @type {(inputs: Settings_Keys_Last_UsedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Last used ${i?.date}`)
};

const id_settings_keys_last_used = /** @type {(inputs: Settings_Keys_Last_UsedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Terakhir dipakai ${i?.date}`)
};

/**
* | output |
* | --- |
* | "Last used {date}" |
*
* @param {Settings_Keys_Last_UsedInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const settings_keys_last_used = /** @type {((inputs: Settings_Keys_Last_UsedInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Keys_Last_UsedInputs, { locale?: "en" | "id" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_settings_keys_last_used(inputs)
	return en_settings_keys_last_used(inputs)
});